// modules
import { handleActions } from 'redux-actions'

import { deletePatientData } from 'src/store/modules/actionCreators'
// actions
import {
  resetMedication,
  setAssignedMedicationList,
  setCarePlanActiveTab,
  setDosageTypes,
  setIntakeList,
  setIntakeValue,
  setMedicationActiveTab,
  setMedicationList,
  setMedicationPredefinedFilter,
  setMedicationReferer,
  setMedicationRuleList,
  setOrderingList,
  setPatientDashboardMedicationList,
  setPatientMedicationList,
  setPatientMedicationValue,
  setPharmacyList,
  setSearchLoading
} from 'src/store/modules/patient/medications'

// constants
import { MEDICATION_TAB_LIST } from 'src/constants'

const initialState = {
  patientMedicationList: [],
  patientMedicationValue: {},
  medicationActiveTab: MEDICATION_TAB_LIST[0],
  intakeList: [],
  intakeValue: {},
  medicationList: [],
  assignedMedicationList: [],
  medicationRuleList: [],
  orderingList: [],
  pharmacyList: [],
  searchLoading: false,
  dosageTypes: [],
  medicationPredefinedFilter: {},
  patientDashboardMedicationList: []
}

export default handleActions(
  {
    [setPatientMedicationList](state, { payload: patientMedicationList }) {
      return {
        ...state,
        patientMedicationList
      }
    },

    [setPatientDashboardMedicationList](
      state,
      { payload: patientDashboardMedicationList }
    ) {
      return {
        ...state,
        patientDashboardMedicationList
      }
    },

    [setPatientMedicationValue](state, { payload: patientMedicationValue }) {
      return {
        ...state,
        patientMedicationValue
      }
    },

    [setIntakeList](state, { payload: intakeList }) {
      return {
        ...state,
        intakeList
      }
    },

    [setMedicationReferer](state, { payload: medicationReferer }) {
      return {
        ...state,
        medicationReferer
      }
    },

    [setMedicationActiveTab](state, { payload: medicationActiveTab }) {
      return {
        ...state,
        medicationActiveTab
      }
    },

    [setCarePlanActiveTab](state, { payload: carePlanActiveTab }) {
      return {
        ...state,
        carePlanActiveTab
      }
    },

    [setIntakeValue](state, { payload: intakeValue }) {
      return {
        ...state,
        intakeValue
      }
    },

    [setMedicationList](state, { payload: medicationList }) {
      return {
        ...state,
        medicationList
      }
    },

    [setAssignedMedicationList](state, { payload: assignedMedicationList }) {
      return {
        ...state,
        assignedMedicationList
      }
    },

    [setMedicationRuleList](state, { payload: medicationRuleList }) {
      return {
        ...state,
        medicationRuleList
      }
    },

    [setOrderingList](state, { payload: orderingList }) {
      return {
        ...state,
        orderingList
      }
    },

    [setPharmacyList](state, { payload: pharmacyList }) {
      return {
        ...state,
        pharmacyList
      }
    },

    [setSearchLoading](state, { payload: searchLoading }) {
      return {
        ...state,
        searchLoading
      }
    },

    [setMedicationPredefinedFilter](
      state,
      { payload: medicationPredefinedFilter }
    ) {
      return {
        ...state,
        medicationPredefinedFilter
      }
    },

    [resetMedication]() {
      return initialState
    },

    [deletePatientData]() {
      return initialState
    },

    [setDosageTypes](state, { payload: dosageTypes }) {
      return {
        ...state,
        dosageTypes
      }
    }
  },
  initialState
)
